import React, { useEffect, useState, useRef } from 'react'
import api from '../../../seller-apis/api'
import { revokedOnly } from '../../../seller-apis/apidataField'
import { Container, Modal, ProgressBar } from 'react-bootstrap';
import OrderCardWeb from '../../common/OrderCardWeb';
import Popup from '../../common/Popup';
import TrackOrderPopup from '../../common/TrackOrder-Popup';
import PaginationCom from '../../common/Pagination';
import servicesApi from '../../../seller-apis/servicesApi';
import { useAlert } from 'react-alert';
import { useOrderDateAlert, resetOrderDateFilter, resolveOrderDateRange, REVOKED_ORDER_DATE_DAYS } from '../useOrderDateAlert';
import { variables } from '../../../Variables.json'
import axios from 'axios';
import '../../../assets/css/rto_delivered.css'
import OrderSKUSearch from '../../common/ProductSearch/OrderSKUSearch';
import moment from 'moment';
import { GenUtilities } from '../../../utilities/GenUtilities';
import MainLoader from '../../common/Loader/PageLoader';
import { useSelector } from 'react-redux';
// var dateFromWeb;
// var dateToWeb;
// Images related
var imagesName = [];
var s3Urls = [];
var imagesNamePackage = []

// Videos related
var videosName = [];
var vids3Urls = [];
var currentLink;
var currReportImg;

// Allowed file types for RTO damage report uploads
const ALLOWED_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp'];
const ALLOWED_IMAGE_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
const ALLOWED_VIDEO_EXTENSIONS = ['.mp4'];
const ALLOWED_VIDEO_MIME_TYPES = ['video/mp4'];

const getFileExtension = (fileName) => {
    if (!fileName || fileName.lastIndexOf('.') === -1) return '';
    return fileName.slice(fileName.lastIndexOf('.')).toLowerCase();
};

const isValidImageFile = (file) => {
    if (!file) return false;
    const ext = getFileExtension(file.name);
    const mime = (file.type || '').toLowerCase();
    const extOk = ALLOWED_IMAGE_EXTENSIONS.includes(ext);
    const mimeOk = mime === '' || ALLOWED_IMAGE_MIME_TYPES.includes(mime);
    return extOk && mimeOk;
};

const isValidVideoFile = (file) => {
    if (!file) return false;
    const ext = getFileExtension(file.name);
    const mime = (file.type || '').toLowerCase();
    const extOk = ALLOWED_VIDEO_EXTENSIONS.includes(ext);
    const mimeOk = mime === '' || ALLOWED_VIDEO_MIME_TYPES.includes(mime);
    return extOk && mimeOk;
};
var globalFilter = {
    "pageNo": 1,
    "spclFilter": {
        
    },
    "sortFilter": {
        "products.tracks.docketReturnDate": -1
    }
};

const Revoked_Delivered = () => {

    var outerdiv;
    var loaderDiv;

    const alert = useAlert();
    const showOrderDateAlert = useOrderDateAlert(alert);

    const stateData = useSelector(state => state?.ActionReducer);
    const [addressName, setAddressName] = useState("");

    const updateOrderFromDate = (value) => {
        const { from, to } = resolveOrderDateRange('from', value, dateFromWeb, dateToWeb);
        setDateFromWeb(from);
        setDateToWeb(to);
    };

    const updateOrderToDate = (value) => {
        const { from, to } = resolveOrderDateRange('to', value, dateFromWeb, dateToWeb);
        setDateFromWeb(from);
        setDateToWeb(to);
    };

    // Web states


    const [allRevokes, setallRevokes] = useState([]);
    const [allRecords, setallRecords] = useState();
    const [ennewloader, setennewloader] = useState();

    // Pagination related

    const [selectedPage, setSelectedPage] = useState(1);
    const [compforPaginationweb, setcompforPaginationweb] = useState("rto");


    //Product Detail Popup

    const [productDetail, setproductDetail] = useState([
        {
            "description": undefined,
            "sdescription": undefined,
            "name": undefined,
            "price": undefined,
            "SKU": undefined,
            "popupVisibility": undefined,
            "images": []
        }
    ]);
    const [isDetailPopupVis, setisDetailPopupVis] = useState("block");
    const [defUrl, setdefUrl] = useState();

    // Web filter related states
    const [isPopupTrackVisWeb, setisPopupTrackVisWeb] = useState("none");
    const [selectedtrackOrderWeb, setselectedtrackOrderWeb] = useState(0);
    const [selectedTrackwithin, setselectedTrackwithin] = useState(0);
    const [detailPPrice, setdetailPPrice] = useState("0");



    // Sort Filter States
    const [sortdatefrom, setsortdatefrom] = useState();
    const [sortdateto, setsortdateto] = useState();


    // const [sortHistdatefrom, setHistsortdatefrom] = useState(moment().subtract(29, 'days').format('YYYY-MM-DD'));
    // const [sortHistdateto, setHistsortdateto] = useState(moment().format('YYYY-MM-DD'));

    const [dateFromWeb, setDateFromWeb] = useState(moment().subtract(30, 'days').format('YYYY-MM-DD'));
    const [dateToWeb, setDateToWeb] = useState(moment().format('YYYY-MM-DD'));

    // Web filter related states

    const [orderId, setOrderId] = useState(undefined);
    const [orderName, setorderName] = useState()
    const [rtoAddress, setrtoAddress] = useState()

    // Modal rto undelivered,report damage
    const [show, setShow] = useState(false);
    const [rtoaction, setrtoaction] = useState("");
    const [damagecomment, setdamagecomment] = useState("")
    const [CurrReportId, setCurrReportId] = useState(0)
    const [CurrReportDate, setCurrReportDate] = useState(0)
    const [ReportType, setReportType] = useState(undefined)
    const [DayDiffer, setDayDiffer] = useState()
    const [RTOClosedDate, setRTOClosedDate] = useState()
    const [RTODeliverDate, setRTODeliverDate] = useState()
    // Images Related 
    const [urlList, seturlList] = useState([]);
    const [urlListshow, seturlListshow] = useState(true);
    const [imgprogress, setimgprogress] = useState();
    const [urlListPackage, seturlListPackage] = useState([]);
    const [urlListshowPackage, seturlListshowPackage] = useState(true);
    const [imgprogressPackage, setimgprogressPackage] = useState();

    // Videos related
    const [vidurlList, setvidurlList] = useState([]);
    const [vidurlListshow, setvidurlListshow] = useState(true);
    const [progress, setProgress] = useState()
    const [minValDate, setMinValDate] = useState("")
    const [searchType, setSearchType] = useState("Product Name");
    // Seller note related

    const [noteModalShow, setNoteModalShow] = useState(false)
    const [currSellerNote, setCurrSellerNote] = useState(0)

    const [vendorId, setvendorId] = useState(localStorage.getItem("vendorId"))
    const [removeFilterClass, setremoveFilterClass] = useState("invent_remove_filter_btn")
    
    //SL-675
    const [totalRcordId, setTotalReordId] = useState([]);
    //<Start-Here> Track button Issue | Ticket : SL-950
    const [selectedTransitDetail, setSelectedTransitDetail] = useState([]);
    const [selectedPopupId, setSelectedPopupId] = useState(null);

    // SL-1155
    const [packageImgUploadError, setPackageImgUploadError] = useState(false);
    const [productImgUploadError, setProductImgUploadError] = useState(false);
    const [videoUploadError, setVideoUploadError] = useState(false);
    const [commentError, setCommentError] = useState(false);
    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false; // skip first render
            return;
        }
        
        if(isPopupTrackVisWeb == "none") 
           setpopupVisibilitytrackWeb(true);
    }, [selectedTransitDetail]);
    //</End-Here> Track button Issue | Ticket : SL-950

    useEffect(() => {
        const { from, to } = resetOrderDateFilter();
        setDateFromWeb(from);
        setDateToWeb(to);
        globalFilter = {
            "pageNo": 1,
            "spclFilter": {

            },
            "sortFilter": {
                "products.tracks.docketReturnDate": -1
            }
        };
        applyFilter();
       

    }, [])

    useEffect(() => {
        if (rtoAddress === "" || rtoAddress === null) {
            setrtoAddress(undefined)
        }
    }, [rtoAddress])


    useEffect(() => {
        if (orderId === "" || orderId === null) {
            setOrderId(undefined)
            if (globalFilter?.filters?.["orderId-Id"]) {
                delete globalFilter.filters?.["orderId-Id"]
                globalFilter.pageNo = 1;
                setSelectedPage(1)
                getOrders()
            }
        }
    }, [orderId])


    useEffect(() => {
        if (orderName === "" || orderName === null) {
            setorderName(undefined)
        }
    }, [orderName])

      const getOrders = () => {
        try {
            applyLoader()
            api.order.revokedOrders(revokedOnly(globalFilter))
                .then((res) => {
                    removeLoader();
                    setallRevokes(res.data);
                    setallRecords(res.totalRecords);
                    if (totalRcordId?.length === 0) { // SL-675
                        setTotalReordId(res?.productId);
                        globalFilter["productId"] = false;
                    }
                })
                .catch((err) => {
                    removeLoader();
                    console.log(err);
                });
        } catch (err) {
            removeLoader()
            console.log(err)
        }
    }

    const handleNoteModalClose = () => {
        setNoteModalShow(false)
    }


    const handleClose = () => {
        setShow(false)
        seturlList([])
        seturlListPackage([])
        setvidurlList([])
        imagesName = []
        imagesNamePackage = []
        s3Urls = []
        videosName = []
        vids3Urls = []
        setvidurlList(true)
        setrtoaction("")
        setdamagecomment("")
    }
    const handleShow = () => setShow(true);



    // Popup showing detail
    function detail(data, price) {
        console.log(data)
        setdetailPPrice(price)
        if (data && data[0] === undefined) {
            setproductDetail(
                [
                    {
                        "description": "No details available",
                        "sdescription": "No short description",
                        "name": undefined,
                        "price": undefined,
                        "SKU": undefined,
                        "popupVisibility": undefined,
                        "images": []
                    }
                ]
            )
        }
        else {
            setproductDetail(data)
        }
    }


    function setpopupVisibilityDetail(e) {
        if (e) {
            setisDetailPopupVis("block")
        }
        else {
            setisDetailPopupVis("none")
        }
    }



    function setpopupVisibilitytrackWeb(e) {
        if (e) {
            setisPopupTrackVisWeb("block")
        }
        else {
            setisPopupTrackVisWeb("none")
        }
    }




    function trackPopupWeb(e, trackNo) {
        setselectedtrackOrderWeb(e)
        setselectedTrackwithin(trackNo)
    }

    // apply loaders

    function applyLoader() {
        outerdiv = document.getElementById("orDeskContain");
        loaderDiv = document.getElementById("enNewLoader");
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        outerdiv.classList.add("div-bk");
    }

    // remove loader

    function removeLoader() {
        loaderDiv.classList.remove("loader-bt");
        setennewloader("none")
        outerdiv.classList.remove("div-bk");
    }


    function paginate(data) {
        applyLoader()
        setCurrSellerNote(0)
        setCurrReportId(0)
        setselectedtrackOrderWeb("0")
        setselectedTrackwithin("0")
        setSelectedPage(data.number)
        globalFilter.pageNo = data.number
        api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
            setallRevokes(res.data)
            removeLoader()
        }).catch(err => console.log(err))
    }


    // function to clear date


    function clearDate() {
        setDateFromWeb("")
        setDateToWeb("")
        setsortdatefrom("")
        setsortdateto("")
    }

    function checkevent(e, spcl,value) {
        if (e.keyCode === 13) {
            setCurrReportId(0)
            if (spcl === "orderId") {
                globalFilter.filters = {
                    ...globalFilter.filters, "orderId-Id": orderId
                }
                globalFilter.pageNo = 1;

                if (orderId === "" || orderId === undefined) {
                    if (compforPaginationweb !== "rto") {
                        setSelectedPage(1)
                        applyLoader()
                        setcompforPaginationweb("rto")

                        api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
                            console.log(res)
                            setallRevokes(res.data)
                            setallRecords(res.totalRecords)
                            removeLoader()
                        }).catch(err => {
                            removeLoader()
                            console.log(err)
                        })
                    }
                }
                else {
                    applyLoader()
                    setSelectedPage(1)
                    setremoveFilterClass("invent_remove_filter_btn_active")
                    globalFilter.pageNo = 1;
                    api.order.revokedOrders(revokedOnly(globalFilter)).then(res => {
                        setcompforPaginationweb("orderId")
                        console.log(res)
                        setallRevokes(res.data)
                        setallRecords(res.totalRecords)
                        removeLoader()
                    }).catch(err => {
                        console.log(err)
                        removeLoader()
                    })
                }
            }
            else if (spcl === "rtoaddress") {

                if (value === "" || value === undefined) {
                    if (compforPaginationweb !== "rto") {
                        delete globalFilter.filters["products.vendorDetails.addrName"]
                        setSelectedPage(1)
                        globalFilter.pageNo = 1;
                        applyLoader()
                        setcompforPaginationweb("rto")
                        api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
                            console.log(res)
                            setallRevokes(res.data)
                            setallRecords(res.totalRecords)
                            removeLoader()
                        }).catch(err => {
                            removeLoader()
                            console.log(err)
                        })
                    }
                }
                else {
                    globalFilter.filters = {
                        ...globalFilter.filters, "products.vendorDetails.addrName": value
                    }
                    applyLoader()
                    setSelectedPage(1)
                    globalFilter.pageNo = 1;
                    api.order.revokedOrders(revokedOnly(globalFilter)).then(res => {
                        setremoveFilterClass("invent_remove_filter_btn_active")
                        setcompforPaginationweb("rtoaddress")
                        setallRevokes(res.data)
                        setallRecords(res.totalRecords)
                        removeLoader()
                    }).catch(err => {
                        console.log(err)
                        removeLoader()
                    })
                }
            }
            else {
                let ordersearchFilter=searchType!='sku'?{"products.productId._id": orderName}:{"products.productId._id": orderName};
                globalFilter.filters = {
                    // ...globalFilter.filters, 
                    ...ordersearchFilter
                }
                if (orderName === "" || orderName === undefined) {
                    if (compforPaginationweb !== "rto") {
                        setSelectedPage(1)
                        applyLoader()
                        globalFilter.pageNo = 1;
                        setcompforPaginationweb("rto")
                        api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
                            console.log(res)
                            setallRevokes(res.data)
                            setallRecords(res.totalRecords)
                            removeLoader()
                        }).catch(err => {
                            removeLoader()
                            console.log(err)
                        })
                    }
                }
                else {
                    applyLoader()
                    setSelectedPage(1)
                    globalFilter.pageNo = 1;
                    api.order.revokedOrders(revokedOnly(globalFilter)).then(res => {
                        setremoveFilterClass("invent_remove_filter_btn_active")
                        setcompforPaginationweb("pName")
                        setallRevokes(res.data)
                        setallRecords(res.totalRecords)
                        removeLoader()
                    }).catch(err => {
                        console.log(err)
                        removeLoader()
                    })
                }
            }
        }
    }


    // Function to restore default
    function defaultweb() {
        setSelectedPage(1)
        clearDate()
        setOrderId("");
        setorderName("");
        let filterData = {
            "pageNo": "1"
        }
        api.order.revokedOrders(revokedOnly(filterData)).then((res) => {
            console.log(res)
            setallRevokes(res.data)
            setallRecords(res.totalRecords)
            setcompforPaginationweb("rto")
        }).catch(err => console.log(err))
    }




    useEffect(() => {
        if (allRecords < 1) {
            alert.show('No Orders Found', {
                "type": "info",
                "timeout": "7000"
            })
        }
    }, [allRecords])


    // Show Image Package
    function showpackage(event) {
        setPackageImgUploadError(false)
        setProductImgUploadError(false)
        setVideoUploadError(false)
        setCommentError(false)
        let comImg;
        let imageFinal;
        let registerImage;
        let isimgsSizevalid = true
        const selectedFiles = Array.from(event.target.files || []);
        if (selectedFiles.length === 0) return;
        const invalidFile = selectedFiles.find(f => !isValidImageFile(f));
        if (invalidFile) {
            alert.info("Only .jpg, .jpeg, .png, .webp images are allowed.");
            event.target.value = "";
            return;
        }
        let limit = event.target.files.length;
        if (imagesNamePackage.length < 2) {
            if (event.target.files.length > 2) {
                alert.info("Max. 2 images can be uploaded")
                limit = 2 - urlListPackage.length;
            }

            else {
                if (urlListPackage.length === 2 || (urlListPackage.length + limit > 2)) {
                    console.log("mnd")
                    limit = 2 - Math.floor(((limit + urlListPackage.length) / 2));
                    limit = Math.abs(limit)
                }

                else {
                    console.log("mnd")
                    limit = 2 - Math.abs((2 - event.target.files.length));
                }
            }
            console.log("dhj")
            for (let i = 0; i < limit; i++) {
                if (event.target.files[i].size > variables.limit.RegisterVendor.storePhoto) {
                    isimgsSizevalid = false
                }
            }
            if (isimgsSizevalid) {
                seturlListshowPackage(false)
                for (let i = 0; i < limit; i++) {
                    var str = event.target.files[i].name;
                    let extension = event.target.files[i].name.slice(event.target.files[i].name.lastIndexOf("."));
                    comImg = str.replace(/[^\w]/g, "");
                    imageFinal = GenUtilities.removeSpacesFromName("img_" + vendorId + "_" + comImg + extension)
                    registerImage = event.target.files[0];
                    imagesNamePackage.push(imageFinal)
                    var data = {
                        "imageName": imageFinal,
                        "type": "products"
                    }
                    servicesApi.saveImage(data).then((res) => {
                        console.log(res)
                        axios({
                            method: 'put',
                            url: res.data,
                            data: registerImage,
                            onUploadProgress: data => {
                                //Set the progress value to show the progress bar
                                setimgprogressPackage(Math.round((100 * data.loaded) / data.total))
                            },
                        })
                            .then(response => {
                                setimgprogressPackage()
                                seturlListPackage(imagesNamePackage)
                                seturlListshowPackage(true)
                            })
                            .catch(error => {
                                console.log(error);
                            });
                    }).catch((err) => console.log(err))
                }
            }
            else {
                console.log("dkdjn")
                alert.info("Please upload images of size less than or equal to 2 Mb")
            }
        }
        else {
            alert.info("Max. 2 images can be uploaded.")
        }
    }


    // Delete image package

    function deleteImgPackage(index) {
        seturlListshowPackage(false)
        seturlListPackage([]);

        imagesNamePackage.splice(index, 1);
        let eleLoader = document.getElementById("loader-Img-upload-package");

        seturlListPackage(imagesNamePackage)

        eleLoader.setAttribute('class', 'spinner-border text-info');

        setTimeout(() => {

            eleLoader.removeAttribute('class');

            seturlListshowPackage(true)
        }, 1000);
    }

    // Show Image 

    function showImage(event) {
        setPackageImgUploadError(false)
        setProductImgUploadError(false)
        setVideoUploadError(false)
        setCommentError(false)
        let comImg;
        let imageFinal;
        let registerImage;
        let isimgsSizevalid = true
        const selectedFiles = Array.from(event.target.files || []);
        if (selectedFiles.length === 0) return;
        const invalidFile = selectedFiles.find(f => !isValidImageFile(f));
        if (invalidFile) {
            alert.info("Only .jpg, .jpeg, .png, .webp images are allowed.");
            event.target.value = "";
            return;
        }
        let limit = event.target.files.length;
        console.log(event.target.files.length)
        if (urlList.length < 2) {
            if (event.target.files.length > 2) {
                alert.info("Max. 2 images can be uploaded")
                limit = 2 - urlList.length;
            }
            else {
                console.log(limit)
                if (urlList.length === 2 || (urlList.length + limit > 2)) {
                    limit = 2 - Math.floor(((limit + urlList.length) / 2));
                    limit = Math.abs(limit)
                }

                else {
                    console.log(limit)
                    limit = 2 - Math.abs((2 - event.target.files.length));
                    console.log(limit)
                }
            }
            for (let i = 0; i < limit; i++) {
                if (event.target.files[i].size > variables.limit.RegisterVendor.storePhoto) {
                    isimgsSizevalid = false
                }
            }
            if (isimgsSizevalid) {
                seturlListshow(false)
                for (let i = 0; i < limit; i++) {
                    var str = event.target.files[i].name;
                    let extension = event.target.files[i].name.slice(event.target.files[i].name.lastIndexOf("."));
                    comImg = str.replace(/[^\w]/g, "");

                    imageFinal = GenUtilities.removeSpacesFromName("img_" + vendorId + "_" + comImg + extension)
                    registerImage = event.target.files[0];
                    imagesName.push(imageFinal)
                    var data = {
                        "imageName": imageFinal,
                        "type": "products"
                    }
                    servicesApi.saveImage(data).then((res) => {
                        axios({
                            method: 'put',
                            url: res.data,
                            data: registerImage,
                            onUploadProgress: data => {
                                //Set the progress value to show the progress bar
                                setimgprogress(Math.round((100 * data.loaded) / data.total))
                            },
                        })
                            .then(response => {
                                setimgprogress()
                                seturlList(imagesName)
                                seturlListshow(true)
                            })
                            .catch(error => {
                                console.log(error);
                            });
                    }).catch((err) => console.log(err))
                    s3Urls.push(imageFinal)
                }
            }
            else {
                alert.info("Please upload images of size less than or equal to 2 Mb")
            }
        }
        else {
            alert.info("Max. 2 images can be uploaded.")
        }
    }

    // Delete image

    function deleteImg(index) {
        seturlListshow(false)
        seturlList([]);

        imagesName.splice(index, 1);
        let eleLoader = document.getElementById("loader-Img-upload");

        seturlList(imagesName)

        eleLoader.setAttribute('class', 'spinner-border text-info');

        setTimeout(() => {

            eleLoader.removeAttribute('class');

            seturlListshow(true)
        }, 1000);
    }

    // Show Video

    function showVideo(event) {
        setPackageImgUploadError(false)
        setProductImgUploadError(false)
        setVideoUploadError(false)
        setCommentError(false)
        const selectedFiles = Array.from(event.target.files || []);
        if (selectedFiles.length === 0) return;
        const invalidFile = selectedFiles.find(f => !isValidVideoFile(f));
        if (invalidFile) {
            alert.info("Only .mp4 videos are allowed.");
            event.target.value = "";
            return;
        }
        if (vidurlListshow) {
            setvidurlListshow(false)
            let comImg;
            let imageFinal;
            let registerImage;
            let videoSize = 0;
            if (event.target.files.length > 1 || vidurlList.length === 1) {
                alert.info("A max of 1 video can be uploaded")
                setvidurlListshow(true)
            }
            else {
                for (let i = 0; i < 1; i++) {
                    videoSize = videoSize + event.target.files[i].size

                }
                if (videoSize <= variables.limit.RTO.videoSize) {
                    for (let i = 0; i < 1; i++) {
                        var str = event.target.files[i].name;
                        let extension = event.target.files[i].name.slice(event.target.files[i].name.lastIndexOf("."));
                        comImg = str.replace(/[^\w]/g, "");
                        imageFinal = GenUtilities.removeSpacesFromName("vid_" + vendorId + "_" + comImg + extension)
                        registerImage = event.target.files[0];
                        var data = {
                            "imageName": imageFinal,
                            "type": "products",
                            "bucket": 'm'
                        }
                        imageFinal = "products/vid_" + vendorId + "_" + comImg + extension
                        servicesApi.saveImage(data).then((res) => {

                            axios({
                                method: 'put',
                                url: res.data,
                                data: registerImage,
                                onUploadProgress: data => {
                                    setProgress(Math.round((100 * data.loaded) / data.total))
                                },
                            })
                                .then(response => {
                                    setProgress()
                                    videosName.push(imageFinal)
                                    setvidurlList(videosName)
                                    setvidurlListshow(true)
                                })
                                .catch(error => {
                                    console.log(error);
                                });
                        }).catch((err) => console.log(err))
                        vids3Urls.push(imageFinal)

                    }
                }
                else {
                    alert.info("A max size of 30 Mb video can be uploaded")
                    setvidurlListshow(true)
                }
            }
        }
    }

    // Delete video

    function deletevideo(index) {
        setvidurlListshow(false)
        setvidurlList([]);

        videosName.splice(index, 1);
        let eleLoader = document.getElementById("loader-Vid-upload");

        setvidurlList(videosName)

        eleLoader.setAttribute('class', 'spinner-border text-info');

        setTimeout(() => {

            eleLoader.removeAttribute('class');

            setvidurlListshow(true)
        }, 1000);
    }


    // report damage function 

    function reportDamage() {
        if (rtoaction === "undelivered") {
            reportUndeliveredFunc()
        }
        else if (rtoaction === "damaged") {
            var result = passValidamage()
            if (result.status) {
                let imgUrlspackage = [];
                let imgUrlsproduct = [];
                for (let i = 0; i < imagesNamePackage.length; i++) {

                    if (i === 0) {
                        let data = {
                            "baseImage": true,
                            "smallImage": false,
                            "thumbnail": false,
                            "visible": false,
                            "image": "products/" + imagesNamePackage[i],
                            "label": imagesNamePackage[i]
                        }
                        imgUrlspackage.push(data);
                    }
                    else {
                        let data = {
                            "baseImage": false,
                            "smallImage": false,
                            "thumbnail": false,
                            "visible": false,
                            "image": "products/" + imagesNamePackage[i],
                            "label": imagesNamePackage[i]
                        }
                        imgUrlspackage.push(data);
                    }

                }
                for (let i = 0; i < imagesName.length; i++) {

                    if (i === 0) {
                        let data = {
                            "baseImage": true,
                            "smallImage": false,
                            "thumbnail": false,
                            "visible": false,
                            "image": "products/" + imagesName[i],
                            "label": imagesName[i]
                        }
                        imgUrlsproduct.push(data);
                    }
                    else {
                        let data = {
                            "baseImage": false,
                            "smallImage": false,
                            "thumbnail": false,
                            "visible": false,
                            "image": "products/" + imagesName[i],
                            "label": imagesName[i]
                        }
                        imgUrlsproduct.push(data);
                    }

                }

                var bodyData = {
                    "reportType": "Damage",
                    "order": allRevokes[CurrReportId].orderId,
                    "packageImage": imgUrlspackage,
                    "productImage": imgUrlsproduct,
                    "video": videosName[0],
                    "status": "OPEN",
                    "sellerNote": damagecomment,
                }
                api.rto.reportRto(bodyData).then((res) => {
                    console.log(res)
                    alert.info("Request submitted successfully")
                    handleClose()
                    applyLoader()
                    setTimeout(() => {
                        api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
                            setallRevokes(res.data)
                            setallRecords(res.totalRecords)
                            removeLoader()
                        }).catch(err => console.log(err))
                    }, 500);
                }).catch(err => console.log(err))
            }
        }
        else {
            alert.info("Please select an option.")
        }
    }

    function passValidamage() {
        let status = true;
        if (imagesNamePackage.length < 1) {
            setPackageImgUploadError(true)
            status = false;
        }
        if (imagesName.length < 1) {
            setProductImgUploadError(true)
            status = false;
        }
        if (videosName.length < 1) {
            setVideoUploadError(true)
            status = false;
        }
        if (damagecomment.length < 1 || damagecomment === null || damagecomment === undefined || damagecomment?.trim() === "") {
            setCommentError(true)
            status = false;
        }
        return { "status": status}
    }

    // Handle report func
    function handleReportRto(id) {
        let rtoTrack = allRevokes[id].products?.[0]?.tracks.find(track => track.rStatus === "RTO-Delivered")
        let notRepDate = new Date(rtoTrack.transitDetail[rtoTrack.transitDetail.length - 1].timestamp);
        let notDt = notRepDate.toUTCString(rtoTrack.transitDetail[rtoTrack.transitDetail.length - 1].timestamp);
        let str_rtoondate = notDt.substr(4, 12);
        let tDDate = new Date();
        var diffDate = tDDate.getTime() - notRepDate.getTime();
        var daydiffer = diffDate / (1000 * 60 * 60 * 24);
        let reportCloseD = notRepDate;
        setCurrReportId(id)
        setRTODeliverDate(str_rtoondate)
        setDayDiffer(daydiffer)
        reportCloseD.setDate(notRepDate.getDate() + 2)
        let d = reportCloseD.toUTCString(reportCloseD)
        setRTOClosedDate(d.substr(4, 12))
        setReportType(undefined)
        if (allRevokes[id].products[0] && allRevokes[id].products[0].rtoReportType) {
            setReportType(allRevokes[id].products[0].rtoReportType)
            let dt = new Date(allRevokes[id].products[0].rtoReportMailSentDate);
            let d = dt.toUTCString(allRevokes[id].products[0].rtoReportMailSentDate);
            let str_mailsentdate = d.substr(4, 12)
            setCurrReportDate(str_mailsentdate)
        }

        handleShow()
    }


    //   Report undelivered rto's

    function reportUndeliveredFunc() {

        let data = {
            "reportType": "Undelivered",
            "order": allRevokes[CurrReportId].orderId,
            "packageImage": [],
            "productImage": [],
            "video": "",
            "status": "OPEN",
            "sellerNote": "",
        }
        api.rto.reportRto(data).then((res) => {
            console.log(res)
            if (res.message === "Success") {
                handleClose()
                alert.success("Reported to Toolsvilla.We will get back to you soon")
                applyLoader()
                setTimeout(() => {
                    api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
                        setallRevokes(res.data)
                        setallRecords(res.totalRecords)
                        removeLoader()
                    }).catch(err => console.log(err))
                }, 500);
            }
        }).catch(err => console.log(err))
    }

    function clearFilter() {
        setorderName("")
        setrtoAddress("")
        setDateFromWeb("")
        setDateToWeb("")
        setOrderId("")
        // setHistsortdatefrom("")
        // setHistsortdateto("")
        applyLoader()
        globalFilter = {
            "pageNo": 1,
            "spclFilter": {
                ...globalFilter.spclFilter
            },
            // "sortFilter": {
            //     "products.tracks.docketReturnDate": -1
            // }
        }
        setSelectedPage(1)
        api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
            setremoveFilterClass("invent_remove_filter_btn")
            setallRevokes(res.data)
            setallRecords(res.totalRecords)
            removeLoader()
        }).catch(err => console.log(err))
    }

    function addNotes(note, orderId, e) {
        console.log(note)
        if (note === undefined || note === "") {
            alert.info("Please type something to save it as note.")
        }
        else {
            api.rto.addRTONote({ "_id": orderId, "note": note }).then((res) => {
                document.getElementById(e).value = ""
                applyLoader()
                setTimeout(() => {
                    alert.success("Note added successfully.")
                    api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
                        setallRevokes(res.data)
                        setallRecords(res.totalRecords)
                        removeLoader()
                    }).catch(err => console.log(err))
                }, 500);
            }).catch(err => console.log(err))

        }
    }

    function showSellerNoteModal(id) {
        setCurrSellerNote(id)
        setNoteModalShow(true)
    }

    // function setdateweb(e, type) {
    //     if (type === "from") {
    //         dateFromWeb = e.target.value;
    //         setHistsortdatefrom(e.target.value)
    //     }
    //     else {
    //         dateToWeb = e.target.value;
    //         setHistsortdateto(e.target.value)
    //     }
    //     if (dateFromWeb !== undefined && dateToWeb != undefined) {
    //         let fromDate = new Date(dateFromWeb)
    //         let toDate = new Date(dateToWeb);
    //         let diffDate = toDate.getTime() - fromDate.getTime()
    //         let daydiffer = diffDate / (1000 * 60 * 60 * 24);
    //         daydiffer = Math.floor(daydiffer)
    //         console.log(daydiffer)
    //         if (daydiffer > 60) {
    //             alert.info('Date range cannot be more than 60 days.', { position: 'top center' })
    //         }
    //         else if (daydiffer < 0) {
    //             alert.info("Please select a valid date range.")
    //         }
    //     }
    // }

    function applyFilter() {
    setselectedtrackOrderWeb(0);
    setSelectedPage(1);
    globalFilter.pageNo = 1;

    // fallback defaults
    const fromDateValue = dateFromWeb || moment().subtract(30, 'days').format('YYYY-MM-DD');
    const toDateValue = dateToWeb || moment().format('YYYY-MM-DD');

    if (!fromDateValue || !toDateValue) {
        showOrderDateAlert("please select both date", "show");
        return false;
    }

    let fromDate = new Date(fromDateValue);
    let toDate = new Date(toDateValue);
    let diffDate = toDate.getTime() - fromDate.getTime();
    let daydiffer = 1 + diffDate / (1000 * 60 * 60 * 24);
    daydiffer = Math.floor(daydiffer);

    if (daydiffer > 60) {
        showOrderDateAlert("Date range cannot be more than 60 days.");
        return 0;
    }

    globalFilter.spclFilter = {
        ...globalFilter.spclFilter,
  "products.tracks": {
        $elemMatch: {
          rStatus: "RTO-Delivered",
            "from-docketReturnDate": fromDateValue + "T00:00:00",
            "to-docketReturnDate": toDateValue + "T23:59:59"
  }
}
    };

    globalFilter.filters = {
        ...globalFilter.filters,
        "products.productId.productName": orderName,
        "products.vendorDetails.addrName-Id": rtoAddress,
        "orderId-Id": orderId
    };

    applyLoader();

    if (orderId || orderName || rtoAddress || (fromDateValue && toDateValue)) {
        setremoveFilterClass("invent_remove_filter_btn_active");
    }

    //SL-675
    globalFilter["productId"] = totalRcordId?.length === 0 ? true : false;

    api.order.revokedOrders(revokedOnly(globalFilter))
        .then((res) => {
            removeLoader();
            setdefUrl("manual-mandava-weeder");
            setallRevokes(res.data);
            setallRecords(res.totalRecords);
            if (totalRcordId?.length === 0) { // SL-675
                setTotalReordId(res?.productId);
                globalFilter["productId"] = false;
            }
        })
        .catch((err) => {
            removeLoader();
            console.log(err);
        });
}

    //<Start-Here> Serach Ticket: SL-675
    const filterSearch=(data)=>{
        //setorderName(data.data);
        //setSearchType(data.type)
        applyLoader();
        globalFilter['filters'] = { ...globalFilter.filters, "products.productId._id": data.data }
        //Search Issue on Other than 1st Page SL-698 and SL-675
        if(globalFilter?.searchIds)
            delete globalFilter['searchIds'];
        globalFilter.pageNo = 1;
        setSelectedPage(1)
        api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
            removeLoader()
            setallRevokes(res.data)
            setallRecords(res.totalRecords)
        }).catch(err => {
            removeLoader()
            console.log(err)
        })
        if(globalFilter?.filters && globalFilter['filters']['products.productId._id'])
            delete globalFilter['filters']['products.productId._id'];
      }
    
       /**
   * API Calling
   */
    const ApiCalling = (flag) => {
        applyLoader()
        if(globalFilter?.searchIds)
          delete globalFilter['searchIds'];
        globalFilter.pageNo = selectedPage;
        if(flag === "reset"){
            delete globalFilter.filters["products.productId._id"];
            globalFilter.pageNo = 1;
            setSelectedPage(1)
        }
        api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
            removeLoader()
            setallRevokes(res.data)
            setallRecords(res.totalRecords)
        }).catch(err => {
            removeLoader()
            console.log(err)
        })
    }
  
   /**
    * Search By Keyword On Enter
    */
    const searchByKeyword = (value, type, productIds) => {
      
      if(productIds.length > 0){
        applyLoader()
        //   if (type === "sku") {
        //       globalFilter['filters'] = { ...globalFilter.filters, "products.productId._id": productIds?.[0] }
        //       if (globalFilter?.searchIds)
        //           delete globalFilter['searchIds'];
        //   }
        //   else {
        //       globalFilter['searchIds'] = productIds
        //   }
        globalFilter['searchIds'] = productIds
        //Search Issue on Other than 1st Page SL-698 and SL-675
        globalFilter.pageNo = 1;
        setSelectedPage(1);
        api.order.revokedOrders(revokedOnly(globalFilter)).then((res) => {
            removeLoader()
            setallRevokes(res.data)
            setallRecords(res.totalRecords)
        }).catch(err => {
            removeLoader()
            console.log(err)
        })
      }
      else{
        setallRevokes([]);
        setallRecords(0);
        
      }
    }
    //</End-Here> Serach Ticket: SL-675

      useEffect(()=>{
        checkevent({ "keyCode": 13 }, "name");
      },[orderName])
    //<Start-here> Ticket : SL-896
    const exportRTOOrders = () => {
        try {
            let btn = document.getElementById("export_Btn");
            btn.innerHTML = `Generating Sheet<span id="dot1"><i class="bi bi-dot"></i></span><span id="dot2"><i class="bi bi-dot"></i></span><span id="dot3"><i class="bi bi-dot"></i></span>`
            api.order.exportRevokedOrders(revokedOnly(globalFilter))
            .then((res) => {
                btn.innerHTML = `Export`;
                const url = window.URL.createObjectURL(res.data);
                const link = document.createElement("a");
                link.href = url;
                link.download = dateFromWeb ? `RTO-Orders-${dateFromWeb}.xlsx` : "RTO-Orders.xlsx";
                link.click();
            }).catch(err => {
                console.log(err)
            })
        } catch (error) {
            console.log(error)
        }
        
    }
    //<End-here> SL-896
    return (
        <>

            <div className="" id="orDeskContain">
                <div class="tab">
                    <div className='d-flex mb-3 justify-content-around'>
                        {/* ******** */}
                        <div className='theme-shed1 p-2'>
                            <div className='m-auto mt-1'>
                                <span className='payment_dates'>RTO Delivered Date -  From: <input type='date' max={dateToWeb || undefined} value={dateFromWeb} onChange={(e) => updateOrderFromDate(e.target.value)}></input></span>
                                <span className='mx-2 payment_dates'>To: <input type='date' min={dateFromWeb || undefined} max={moment().format('YYYY-MM-DD')} value={dateToWeb} onChange={(e) => updateOrderToDate(e.target.value)}></input></span>
                                <span><button className='payment_btn_export px-3 py-1 ff_Pop fs-14' onClick={() => applyFilter()}>Apply</button></span>
                                {/* <span><button className={`payment_btn_export px-3 py-1 ff_Pop fs-14 ms-1 ${removeFilterClass}`} onClick={() => clearFilter()}>Clear</button></span> */}
                                {/* SL-896 Export RTO Orders */}
                                {/* Export button */}
                                <span style={{marginLeft:'10px'}}><button className="payment_btn_export px-3 py-1 ff_Pop fs-14" id="export_Btn" onClick={() => exportRTOOrders()}>Export</button></span>
                            </div>
                        </div>
                        {/* ****** */}
                    </div>
                    {/* <Container> */}
                    <div className="table-responsive">
                    <table class="ord_table new-table-design" style={{ "width": "100%" }}>
                        <thead>
                            <tr className='table_ord_title_row'>

                                <th className='thead_title' style={{ "width": "10%" }}>Order ID
                                    <br></br>
                                    <input type="text" value={orderId} name="name" placeholder='Search..' className='w-90 order_table_srch_input' onChange={(e) => setOrderId(e.target.value)} onKeyUp={(e) => checkevent(e, "orderId")} />
                                    <i class="fa fa-search pointer search-space order_table_srch_input_icon" aria-hidden="true" onClick={(data) => checkevent(data = { "keyCode": 13 }, "orderId")}></i>
                                </th>

                                {/* <th className='thead_title pb-1' style={{ "width": "5%" }}>RTO Date<br></br>
                                </th> */}

                                <th className='thead_title' style={{ "width": "10%" }}>Product image</th>

                                <th className='thead_title' style={{ "width": "20%" }}>Product Name & SKU
                                <br/>
                                    <OrderSKUSearch 
                                    filterSearch={filterSearch}
                                    searchNewEnq={setorderName}
                                    from={"orders"}
                                    flag="Order" // set flag
                                    apiCall={ApiCalling}
                                    apiurl="searchSellerOrdersFilter"
                                    ordersSearchParam={globalFilter}
                                    data="filedData"
                                    totalRcordId={totalRcordId}
                                    searchByKeyword={searchByKeyword}
                                    />
                                </th>

                                <th className='thead_title' style={{ "width": "10%" }}>RTO Status</th>

                                <th className='thead_title' style={{ "width": "12%" }}>Tracking Details</th>

                                <th className='thead_title' style={{ "width": "10%" }}>RTO Address
                                       <div className="dropdown-wrapper">
                                            <select
                                                value={addressName}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setAddressName(value);
                                                    //Immediately trigger search after selection
                                                    checkevent({ keyCode: 13 }, "rtoaddress", value);
                                                }}
                                            >
                                                <option value="">All</option>
                                                {stateData?.addresses?.data.map((address) => (
                                                    <option key={address._id} value={address.firstName}>
                                                        {address.firstName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                </th>

                                <th className='thead_title' style={{ "width": "10%" }}>Remarks</th>

                                <th className='thead_title' style={{ "width": "10%" }}>Notes
                                    <br></br>
                                    <input type="text" placeholder='Search..' />
                                    <i className="fa fa-search pointer search-space order_table_srch_input_icon" aria-hidden="true"></i>
                                </th>
                            </tr>

                        </thead>
                        <tbody>

                            {allRevokes.length > 0 ? allRevokes.map((item, index) => {
                                let baseImg;
                                let date = new Date(item.orderPlaceDate);
                                let d = date.toUTCString(item.orderPlaceDate);
                                let newd = d.substr(4, 12)

                                if (item.products.length > 0 && item.products[0].productId) {
                                    item.products[0].productId.images.map((item) => {
                                        if (item.baseImage === true) {
                                            if (item.image.startsWith("products")) {
                                                baseImg = item.image;
                                            }
                                            else {
                                                let img = item.image.substr("41")
                                                baseImg = img;
                                            }
                                        }
                                    })
                                    return (
                                        <OrderCardWeb id={index}
                                            type="New-Orders"
                                            nicknameAdd={item.products && item.products[0] && item.products[0].vendorDetails && item.products[0].vendorDetails.addrName ? item.products[0].vendorDetails.addrName : undefined}
                                            lead={item._id}
                                            date={newd}
                                            key={item._id}
                                            addNotes={addNotes}
                                            pdetail={detail}
                                            url={item.products[0].productId.urlKey}
                                            popupdetailVis={setpopupVisibilityDetail}
                                            revokes={item.products[0].revokes}
                                            orderId={item.orderId}
                                            productName={item.products[0].productId.productName}
                                            sku={item.products[0].productId.SKU}
                                            price={item.purchase_price}
                                            quantity={item.products[0].quantity}
                                            status={item.status}
                                            invoices={item.products[0].tracks}
                                            image={baseImg}
                                            showSellerNoteModal={showSellerNoteModal}
                                            revokeReason={item.revoke}
                                            vendor={item.vendor}
                                            pro={item.products[0]}
                                            popupVisibility={setpopupVisibilitytrackWeb}
                                            fun={trackPopupWeb}
                                            reportUndeliveredFunc={reportUndeliveredFunc}
                                            handleReportRto={handleReportRto}
                                            rtoReportId={item.products[0].rtoReportId}
                                            from="rto"
                                            //SL-950
                                            onTransitFetched={(_id,detail, orderId, trackNo) => {
                                                setSelectedPopupId(_id);
                                                setSelectedTransitDetail(detail);
                                                setselectedtrackOrderWeb(orderId);
                                                setselectedTrackwithin(trackNo);
                                            }}
                                        />
                                    )
                                }
                                else {
                                    console.log(index)
                                    return (
                                        <OrderCardWeb id={index}
                                            type="New-Orders"
                                            key={item._id}
                                            lead={item._id}
                                            orderId={item.orderId}
                                            status="noprodetail"
                                        />
                                    )
                                }

                            }) : ennewloader === "none" ? (
                              <>
                                <tr className="order-no-results-row">
                                  <td colSpan={8} className="order-no-results-cell">No Results Found</td>
                                </tr>
                              </>
                            ) : null}
                            
                        </tbody>
                    </table>
                    </div>
                    {/* </Container> */}



                    <div class="d-flex justify-content-center" id="enNewLoader" >
                        <div style={{ "display": ennewloader }}>
                            <MainLoader/>
                        </div>
                    </div>

                    <PaginationCom
                        number={allRecords}
                        activ={selectedPage}
                        paginate={paginate}
                        comp={compforPaginationweb}
                    />




                </div>
                {/* Track detail for web | Ticket : SL-950 */}
                {console.log('isPopupTrackVisWeb',isPopupTrackVisWeb)}
                {isPopupTrackVisWeb == 'block' && 
                <div id="popupTrackweb" className={`overlay ${isPopupTrackVisWeb == 'block' ? 'visible' : ''}`} style={{ "display": "block" }}>
                    <TrackOrderPopup
                    type="New-Orders"
                    id={selectedPopupId}
                    trackDetail={selectedTransitDetail}
                    popupVisibility={setpopupVisibilitytrackWeb}
                    /> 
                </div>}
                
                <div id="popupDetail" className="overlay" style={{ "display": isDetailPopupVis }}>
                    <Popup
                        description={productDetail[0].description}
                        sdescription={productDetail[0].shortDescription}
                        descriptionNew={productDetail[0].descriptionNew}
                        specificationNew={productDetail[0].specificationNew}
                        name={productDetail[0].productName}
                        price={null}
                        SKU={productDetail[0].SKU}
                        popupVisibility={setpopupVisibilityDetail}
                        images={productDetail[0].images}
                        from="categories"
                        videos={productDetail[0].videos}
                        fixedImage={true}
                    />
                </div>


                {/* Modal for report undelivered and damage product */}

                <Modal show={show} onHide={handleClose}
                    backdrop="static"
                    keyboard={false} className="modal_1" size="lg" centered >
                    {allRevokes.length > 0 && allRevokes[CurrReportId].products && allRevokes[CurrReportId].products[0] ?
                        <Modal.Body className='modal_body_1'>
                            <button className='my_Modal_close_btn' onClick={() => handleClose()}>X</button>
                            <div className='row'>
                                <div className='col-6'>
                                    <p>Order Id:- {allRevokes[CurrReportId].orderId}</p>
                                </div>
                                <div className='col-6'>
                                    <p className='float-right'>RTO delivered on :- {RTODeliverDate}</p>
                                </div>
                            </div>

                            <div className='modal_media_1'>

                                {/* Product Details */}
                                <div className='row'>
                                    <div className='col-4 modal_1_img_cntn'>
                                        {
                                            allRevokes[CurrReportId].products[0].productId.images.map((item) => {
                                                if (item.baseImage === true) {
                                                    if (item.image.startsWith("products")) {
                                                        currReportImg = item.image;
                                                    }
                                                    else {
                                                        let img = item.image.substr("41")
                                                        currReportImg = img;
                                                    }
                                                }
                                            })
                                        }
                                        <img src={"https://s3.toolsvilla.com/" + currReportImg} alt="product" width="100%" height="100%" />
                                    </div>
                                    <div className='col-8'>
                                        <p>{allRevokes[CurrReportId].products[0].productId.productName}</p>
                                    </div>
                                </div>


                                {/* If RTO action taking time has expired */}
                                {
                                    DayDiffer > 2 && <>
                                        {
                                            ReportType === undefined ?
                                                <p>
                                                    <span className=''>This item is no longer available for return/exchange.</span>
                                                    <br></br>
                                                    <span> The product is delivered to you on <span className='text-primary'>{RTODeliverDate}</span>. The Report window closed on <span className='text-primary'>{RTOClosedDate}.</span></span>   <br></br>
                                                    <span>For any other technical assistance, please write to us on :- </span> <br></br>
                                                    <a className='link-primary ff_pop' href="mailto:support@toolsvilla.com">📧 support@toolsvilla.com</a>
                                                </p> : ReportType === "Damage" ? <p className='f-600 text-danger  text-center'>
                                                    RTO Damaged has already been reported on {CurrReportDate}
                                                </p> : ReportType === "Undelivered" ? <p className='f-600 text-danger text-center'>RTO Undelivered has already been reported on {CurrReportDate}</p> : <></>
                                        }
                                    </>
                                }


                                {/* RTO damage */}
                                {
                                    ReportType === "Damage" && DayDiffer <= 2 && <>
                                        <div className='modal_1_actions'>
                                            <div className=''>
                                                <input type='radio' id="damaged" name="rtoaction" value="damaged" defaultChecked />
                                                <label htmlFor='damaged'>Received damaged product</label>
                                            </div>
                                        </div>
                                        <p className='f-600 text-danger  text-center'>RTO damage has already been reported on {CurrReportDate}</p>
                                    </>
                                }




                                {/* Undelivered and less than 2 days */}
                                {
                                    ReportType === "Undelivered" && DayDiffer <= 2 && <>
                                        {/* Action */}
                                        <div className='modal_1_actions' onChange={(e) => setrtoaction(e.target.value)}>
                                            <div className=''>
                                                <input type='radio' id="damaged" name="rtoaction" value="damaged" />
                                                <label htmlFor='damaged'>Received damaged product</label>
                                            </div>
                                            <div className=''>
                                                <input type='radio' id="undelivered" name="rtoaction" value="undelivered" defaultChecked disabled />
                                                <label htmlFor='undelivered'>Undelivered</label>
                                            </div>
                                        </div>


                                        {/* If had chosen option damaged */}
                                        {rtoaction === "damaged" ? <div className='w-100'>
                                            <div className='d-flex justify-content-center'>
                                                <div className="w-30 text-center">
                                                    {!urlListshowPackage ? <></> : <><label htmlFor='package' for="package">
                                                        <span className='gry fs-10'>Add Package image *</span>
                                                        <br></br>
                                                        <i class="fa fa-camera upload-img ms-2" aria-hidden="true"></i>
                                                        <br></br><span className="gry fs-10">(Max. 2 Mb)</span>
                                                        <br></br><span className="gry fs-10">(jpg, jpeg, png, webp)</span>
                                                    </label>
                                                    </>}
                                                    <input type='file' className='uploadFile' id="package" multiple accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp" onChange={(e) => showpackage(e)} />
                                                    {packageImgUploadError && <span className="text-danger fs-10 f-700">Please upload package image.</span>}
                                                    {imgprogressPackage && <ProgressBar id="progress-A" now={imgprogressPackage} label={`${imgprogressPackage}%`} />}
                                                    <div role="status" id="loader-Img-upload-package">
                                                        <ul id="contain-Img-Pro " className="d-flex l-n over-flow mb-0 justify-content-center" style={{ width: "100%" }}>
                                                            {urlListshowPackage === true ? urlListPackage.map((item, index) => {
                                                                return (
                                                                    <li className="text-center w-20 li_add_pro me-1">
                                                                        <div className='w-100 h-50'>
                                                                            <img src={"https://s3.toolsvilla.com/mob/products/" + item} width="100%" height="100%" key={index} alt="img" />
                                                                        </div>

                                                                        {/* <br></br> */}
                                                                        {/* <i className="bi bi-trash fs-14 text-red delete_Icon_addPro" onClick={() => deleteImg(index)}></i> */}
                                                                        <i className="bi bi-x-square-fill fs-14 text-yellow " onClick={() => deleteImgPackage(index)}></i>
                                                                    </li>
                                                                )
                                                            }) : <></>}
                                                        </ul>


                                                    </div>
                                                </div>



                                                <div className="w-30 text-center">
                                                    {!urlListshow ? <></> : <><label htmlFor='product'>
                                                        <span className='gry fs-10'>Add Product image *</span>
                                                        <br></br>
                                                        <i class="fa fa-camera upload-img ms-2" aria-hidden="true"></i>
                                                        <br></br><span className="gry fs-10">(Max. 2 Mb)</span>
                                                        <br></br><span className="gry fs-10">(jpg, jpeg, png, webp)</span>
                                                    </label></>}
                                                    {imgprogress && <ProgressBar id="progress-B" now={imgprogress} label={`${imgprogress}%`} />}
                                                    <input type='file' className='uploadFile' id="product" multiple accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp" onChange={(e) => showImage(e)} />
                                                    {productImgUploadError && <span className="text-danger fs-10 f-700">Please upload product image.</span>}
                                                    <div role="status" id="loader-Img-upload">
                                                        <ul id="contain-Img-Pro " className="d-flex l-n over-flow mb-0 justify-content-center" style={{ width: "100%" }}>
                                                            {urlListshow === true ? urlList.map((item, index) => {
                                                                return (
                                                                    <li className="text-center w-20 li_add_pro me-1">
                                                                        <div className='w-100 h-50'>
                                                                            <img src={"https://s3.toolsvilla.com/mob/products/" + item} width="100%" height="100%" key={index} alt="img" />
                                                                        </div>

                                                                        {/* <br></br> */}
                                                                        {/* <i className="bi bi-trash fs-14 text-red delete_Icon_addPro" onClick={() => deleteImg(index)}></i> */}
                                                                        <i className="bi bi-x-square-fill fs-14 text-yellow " onClick={() => deleteImg(index)}></i>
                                                                    </li>
                                                                )
                                                            }) : <></>}
                                                        </ul>


                                                    </div>
                                                </div>


                                                <div className="w-30 text-center">
                                                    {!vidurlListshow ? <></> : <><label htmlFor='video'>
                                                        <span className='gry fs-10'>Add Video *</span>
                                                        <br></br>
                                                        <i class="fa fa-play-circle upload-img px-3 "></i>
                                                        <br></br><span className="gry fs-10">(Max. 30 Mb)</span>
                                                        <br></br><span className="gry fs-10">(mp4)</span>
                                                    </label>
                                                        <input type='file' className='uploadFile' accept=".mp4,video/mp4" id="video" onChange={(e) => showVideo(e)} />
                                                        {videoUploadError && <span className="text-danger fs-10 f-700">Please upload video.</span>}
                                                    </>}
                                                    {progress && <ProgressBar id="progress-C" now={progress} label={`${progress}%`} />}
                                                    <div role="status" id="loader-Vid-upload">
                                                        <ul id="contain-Img-Pro " className="d-flex l-n over-flow mb-0 justify-content-center" style={{ width: "100%" }}>
                                                            {vidurlListshow === true ? vidurlList.length > 0 && vidurlList.map((item, index) => {
                                                                return (
                                                                    <>
                                                                        <li className="text-center w-20 li_add_pro">
                                                                            <div className='w-100 h-50'>
                                                                                <video src={"https://media.toolsvilla.com/mob/" + item} width="100%" height="100%" className="vid-P" key={index} alt="img" />
                                                                            </div>

                                                                            {/* <br></br> */}
                                                                            <i className="bi bi-x-square-fill fs-14 text-yellow" onClick={() => deletevideo(index)}></i>
                                                                        </li>
                                                                    </>
                                                                )
                                                            }) : <></>}
                                                        </ul>
                                                        {/* <span className="toastAlert" style={{ "display": toastimageUpload }}><i class="fa fa-exclamation" aria-hidden="true"></i> Please select image</span> */}
                                                    </div>
                                                </div>


                                            </div>

                                            {/* For adding notes */}
                                            <div className=''>
                                                <label htmlFor='comment' className='fs-14'>Add comment (Max. 300 characters)</label>
                                                <textarea rows={5} style={{ "width": "100%" }} id="comment" className='fs-13' value={damagecomment} onChange={(e) => setdamagecomment(e.target.value.slice(0, 300))} />
                                                <span className='fs-12'>{damagecomment.length} character(s)</span>
                                                {commentError && <span className="text-danger fs-10 f-700">Please add comment.</span>}
                                            </div>
                                        </div> : <></>}
                                        <p className='f-600 text-danger  text-center'>RTO Undelivered has already been reported on {CurrReportDate}</p>
                                        <div className='text-center'>
                                            <button className='tools_btn' onClick={() => reportDamage()}>Submit</button>
                                        </div>
                                    </>
                                }



                                {/* No action taken */}
                                {
                                    ReportType === undefined && DayDiffer <= 2 && <>
                                        {/* Action */}
                                        <div className='modal_1_actions' onChange={(e) => setrtoaction(e.target.value)}>
                                            <div className=''>
                                                <input type='radio' id="damaged" name="rtoaction" value="damaged" />
                                                <label htmlFor='damaged'>Received damaged product</label>
                                            </div>
                                            <div className=''>
                                                <input type='radio' id="undelivered" name="rtoaction" value="undelivered" />
                                                <label htmlFor='undelivered'>Undelivered</label>
                                            </div>
                                        </div>


                                        {/* If had chosen option damaged */}
                                        {rtoaction === "damaged" ? <div className='w-100'>
                                            <div className='d-flex justify-content-center'>
                                                <div className="w-30 text-center">
                                                    {!urlListshowPackage ? <></> : <><label htmlFor='package' for="package">
                                                        <span className='gry fs-10'>Add Package image *</span>
                                                        <br></br>
                                                        <i class="fa fa-camera upload-img ms-2" aria-hidden="true"></i>
                                                        <br></br><span className="gry fs-10">(Max. 2 Mb)</span>
                                                        <br></br><span className="gry fs-10">(jpg, jpeg, png, webp)</span>
                                                    </label>
                                                    </>}
                                                    <input type='file' className='uploadFile' id="package" multiple accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp" onChange={(e) => showpackage(e)} />
                                                    {packageImgUploadError && <p className='text-danger fs-10 f-700'>Please upload the image</p>}
                                                    {imgprogressPackage && <ProgressBar id="progress-A" now={imgprogressPackage} label={`${imgprogressPackage}%`} />}
                                                    <div role="status" id="loader-Img-upload-package">
                                                        <ul id="contain-Img-Pro " className="d-flex l-n over-flow mb-0 justify-content-center" style={{ width: "100%" }}>
                                                            {urlListshowPackage === true ? urlListPackage.map((item, index) => {
                                                                return (
                                                                    <li className="text-center w-20 li_add_pro me-1">
                                                                        <div className='w-100 h-50'>
                                                                            <img src={"https://s3.toolsvilla.com/mob/products/" + item} width="100%" height="100%" key={index} alt="img" />
                                                                        </div>

                                                                        {/* <br></br> */}
                                                                        {/* <i className="bi bi-trash fs-14 text-red delete_Icon_addPro" onClick={() => deleteImg(index)}></i> */}
                                                                        <i className="bi bi-x-square-fill fs-14 text-yellow " onClick={() => deleteImgPackage(index)}></i>
                                                                    </li>
                                                                )
                                                            }) : <></>}
                                                        </ul>


                                                    </div>
                                                </div>



                                                <div className="w-30 text-center">
                                                    {!urlListshow ? <></> : <><label htmlFor='product'>
                                                        <span className='gry fs-10'>Add Product image *</span>
                                                        <br></br>
                                                        <i class="fa fa-camera upload-img ms-2" aria-hidden="true"></i>
                                                        <br></br><span className="gry fs-10">(Max. 2 Mb)</span>
                                                        <br></br><span className="gry fs-10">(jpg, jpeg, png, webp)</span>
                                                    </label></>}
                                                    {imgprogress && <ProgressBar id="progress-B" now={imgprogress} label={`${imgprogress}%`} />}
                                                    <input type='file' className='uploadFile' id="product" multiple accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp" onChange={(e) => showImage(e)} />
                                                    {productImgUploadError && <p className='text-danger fs-10 f-700'>Please upload the image</p>}
                                                    <div role="status" id="loader-Img-upload">
                                                        <ul id="contain-Img-Pro " className="d-flex l-n over-flow mb-0 justify-content-center" style={{ width: "100%" }}>
                                                            {urlListshow === true ? urlList.map((item, index) => {
                                                                return (
                                                                    <li className="text-center w-20 li_add_pro me-1">
                                                                        <div className='w-100 h-50'>
                                                                            <img src={"https://s3.toolsvilla.com/mob/products/" + item} width="100%" height="100%" key={index} alt="img" />
                                                                        </div>

                                                                        {/* <br></br> */}
                                                                        {/* <i className="bi bi-trash fs-14 text-red delete_Icon_addPro" onClick={() => deleteImg(index)}></i> */}
                                                                        <i className="bi bi-x-square-fill fs-14 text-yellow " onClick={() => deleteImg(index)}></i>
                                                                    </li>
                                                                )
                                                            }) : <></>}
                                                        </ul>


                                                    </div>
                                                </div>


                                                <div className="w-30 text-center">
                                                    {!vidurlListshow ? <></> : <><label htmlFor='video'>
                                                        <span className='gry fs-10'>Add Video *</span>
                                                        <br></br>
                                                        <i class="fa fa-play-circle upload-img px-3 "></i>
                                                        <br></br><span className="gry fs-10">(Max. 30 Mb)</span>
                                                        <br></br><span className="gry fs-10">(mp4)</span>
                                                    </label>
                                                        <input type='file' className='uploadFile' accept=".mp4,video/mp4" id="video" onChange={(e) => showVideo(e)} />
                                                         {videoUploadError && <p className='text-danger fs-10 f-700'>Please upload the video</p>}
                                                    </>}
                                                    {progress && <ProgressBar id="progress-C" now={progress} label={`${progress}%`} />}
                                                    <div role="status" id="loader-Vid-upload">
                                                        <ul id="contain-Img-Pro " className="d-flex l-n over-flow mb-0 justify-content-center" style={{ width: "100%" }}>
                                                            {vidurlListshow === true ? vidurlList.length > 0 && vidurlList.map((item, index) => {
                                                                return (
                                                                    <>
                                                                        <li className="text-center w-20 li_add_pro">
                                                                            <div className='w-100 h-50'>
                                                                                <video src={"https://media.toolsvilla.com/mob/" + item} width="100%" height="100%" className="vid-P" key={index} alt="img" />
                                                                            </div>

                                                                            {/* <br></br> */}
                                                                            <i className="bi bi-x-square-fill fs-14 text-yellow" onClick={() => deletevideo(index)}></i>
                                                                        </li>
                                                                    </>
                                                                )
                                                            }) : <></>}
                                                        </ul>
                                                        {/* <span className="toastAlert" style={{ "display": toastimageUpload }}><i class="fa fa-exclamation" aria-hidden="true"></i> Please select image</span> */}
                                                    </div>
                                                </div>


                                            </div>

                                            {/* For adding notes */}
                                            <div className=''>
                                                <label htmlFor='comment' className='fs-14'>Add comment (Max. 300 characters)</label>
                                                <textarea rows={5} style={{ "width": "100%" }} id="comment" className='fs-13' value={damagecomment} onChange={(e) => setdamagecomment(e.target.value.slice(0, 300))} />
                                                <span className='fs-12'>{damagecomment.length} character(s)</span>
                                                {commentError && <p className='text-danger fs-10 f-700'>Please add comment</p>}
                                            </div>
                                        </div> : <></>}
                                        <div className='text-center'>
                                            <button className='tools_btn' onClick={() => reportDamage()}>Submit</button>
                                        </div>
                                    </>
                                }


                            </div>
                        </Modal.Body> : <></>
                    }
                </Modal>

                {/* Modal for seller notes */}

                <Modal show={noteModalShow} onHide={handleNoteModalClose}
                    backdrop="static"
                    keyboard={false} className="modal_1" size="lg" centered >
                    {allRevokes.length > 0 && allRevokes[currSellerNote].slNotes && allRevokes[currSellerNote].slNotes.length > 0 ?
                        <Modal.Body className='modal_body_1 rto_deliver_seller_notes_modbody'>
                            <button className='my_Modal_close_btn' onClick={() => handleNoteModalClose()}>X</button>
                            <div className='modal_media_1 rto_deliver_seller_notes_modbody_div'>
                                <table className='rto_deliver_seller_notes_table' width="100%">
                                    <thead className='text-center'>
                                        <th className='w-30'>Created On</th>
                                        <th className='w-70'>Note</th>
                                    </thead>
                                    <tbody>
                                        {allRevokes[currSellerNote].slNotes.map((item, index) => {
                                            let date = new Date(item.createdAt);
                                            let d = date.toUTCString(item.createdAt);
                                            let newd = d.substr(4, 12)
                                            return (
                                                <>
                                                    <tr>
                                                        <td className='text-black fs-14'>{newd}</td>
                                                        <td className='fs-14'>{item.note}</td>
                                                    </tr>
                                                </>
                                            )
                                        })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </Modal.Body> : <Modal.Body className='modal_body_1'>
                            <button className='my_Modal_close_btn' onClick={() => handleNoteModalClose()}>X</button>
                            <div className='modal_media_1'>
                                <p className='text-red fs-20 text-center'>No notes found!</p>
                            </div>
                        </Modal.Body>
                    }
                </Modal>
            </div>
        </>

    )
}

export default Revoked_Delivered;